var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedSysmbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92143 4.558C8.39661 3.38274 9.76734 2.8552 10.9078 3.40865L12.3119 4.08999C12.5557 4.2083 12.8387 4.21546 13.0882 4.10965L14.5249 3.50022C15.6919 3.0052 17.0342 3.60142 17.4493 4.79922L17.9603 6.27382C18.0491 6.52986 18.2441 6.73505 18.4953 6.83662L19.9422 7.42162C21.1175 7.8968 21.645 9.26753 21.0915 10.408L20.4102 11.8121C20.2919 12.0559 20.2847 12.3389 20.3905 12.5883L21 14.0251C21.495 15.1921 20.8988 16.5344 19.701 16.9495L18.2264 17.4605C17.9703 17.5493 17.7651 17.7443 17.6636 17.9955L17.0786 19.4424C16.6034 20.6176 15.2327 21.1452 14.0922 20.5917L12.6881 19.9104C12.4443 19.7921 12.1613 19.7849 11.9119 19.8907L10.4751 20.5002C9.30807 20.9952 7.9658 20.399 7.55069 19.2012L7.03966 17.7266C6.95093 17.4705 6.75587 17.2653 6.50466 17.1638L5.0578 16.5788C3.88254 16.1036 3.35501 14.7329 3.90845 13.5924L4.5898 12.1883C4.7081 11.9445 4.71527 11.6615 4.60945 11.412L4.00003 9.97531C3.50501 8.80827 4.10123 7.466 5.29903 7.05089L6.77363 6.53985C7.02966 6.45112 7.23485 6.25607 7.33643 6.00485L7.92143 4.558Z",
    fill: "#05CA49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7541 9.11737C17.0616 9.42489 17.0616 9.9235 16.7541 10.231L11.4946 15.4905C11.3469 15.6382 11.1466 15.7212 10.9378 15.7212C10.7289 15.7212 10.5286 15.6382 10.3809 15.4905L8.24334 13.353C7.93581 13.0454 7.93581 12.5468 8.24334 12.2393C8.55087 11.9318 9.04947 11.9318 9.357 12.2393L10.9378 13.82L15.6404 9.11737C15.948 8.80984 16.4466 8.80984 16.7541 9.11737Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedSysmbol);
export default __webpack_public_path__ + "static/media/verified-sysmbol.49ab949105da6e5bdf22260a88e8d195.svg";
export { ForwardRef as ReactComponent };